import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import {
  Typography,
  Grid,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Divider,
  Table,
  TableContainer,
} from "@material-ui/core";
import useStyles from "./styles";
import SearchIcon from "@mui/icons-material/Search";
import { fetchSocietyId } from "../../../contextAPI/fetchSociety";
import { resolveErrorMessage } from "../../../services/service";
import * as api from "../../../api/index";
import { handlePropertyName } from "../../../contextAPI/NamingConvention";

const ShowPropertyModal = (props) => {
  const {
    isShowProperty,
    setisShowProperty,
    sector,
    dayWiseAllData,
    getDynamicCount,
    selectedDay,
    currentIndexForSubCount,
    expProp,
    isView,
  } = props;

  const classes = useStyles();
  const [search, setsearch] = useState("");
  const [loader, setloader] = useState(false);
  const [allProperties, setallProperties] = useState(null);
  const [allPropertyCount, setallPropertyCount] = useState(0);

  useEffect(() => {
    if (isShowProperty) {
      let arr = [];
      if (dayWiseAllData?.length > 0 && search === "") {
        let newArr = dayWiseAllData?.filter((obj) => obj.day === selectedDay);
        if (newArr && newArr[currentIndexForSubCount]?.properties) {
          arr = newArr[currentIndexForSubCount]?.properties;
        } else {
          return null;
        }
      }

      handleGetProperties(arr);
    }
  }, [search, isShowProperty]);

  const handleGetProperties = async (exceptionProperty) => {
    setloader(true);
    setTimeout(() => {
      setloader(false);
    }, 40000);
    try {
      let sendData = {
        filters: {
          sector,
          searchKey: search,
          societyId: fetchSocietyId(),
          exceptionProperty: isView ? expProp : exceptionProperty,
          isException: currentIndexForSubCount > 0 ? true : false,
        },
        page: 1,
        limit: 2000,
      };
      const res = await api.vendorConfigurationGetProperty(sendData);
      if (res?.data?.success) {
        setallProperties(res?.data?.properties?.data);
        setallPropertyCount(res?.data?.properties?.allProperties);
        setloader(false);
      }
    } catch (error) {
      setloader(false);
      resolveErrorMessage(error);
    }
  };

  return (
    <Modal open={isShowProperty}>
      <Paper
        style={{
          backgroundColor: "#e6e7f0",
          boxShadow: "2px 2px 8px #000",
          borderRadius: 7,
          minWidth: "450px",
          maxWidth: "45vw",
          overflow: "auto",
        }}
        className={classes.ModalView}
      >
        <Grid
          container
          style={{
            textAlign: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            style={{
              color: "#000",
              textAlign: "center",
              fontWeight: "bold",
              marginLeft: 10,
              fontSize: 17,
              opacity: 1,
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            {handlePropertyName()} : {allProperties?.length}
          </Typography>
        </Grid>
        <Divider
          style={{
            marginTop: 10,
            marginBottom: 10,
            backgroundColor: "#000",
          }}
        />
        <Grid>
          <>
            <Grid
              container
              style={{ marginBottom: "10px", justifyContent: "space-between" }}
            >
              <div class="box" style={{ backgroundColor: "#fff" }}>
                <input
                  type="text"
                  placeholder="search by name"
                  autoFocus
                  onChange={(event) => {
                    setsearch(event.target.value);
                  }}
                  value={search}
                />
                <div className="searchIcon">
                  <SearchIcon />
                </div>
              </div>
            </Grid>

            <TableContainer
              component={Paper}
              style={{
                borderRadius: 10,
                marginRight: 10,
                height: 500,
              }}
            >
              <Table style={{ height: "max-content" }}>
                {!loader && (
                  <TableBody>
                    {allProperties?.map((row, index) => (
                      <TableRow key={row._id}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{
                            color: "black",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          <Typography className={classes.textname}>
                            {index + 1}. {row?.name}&nbsp;({row?.type})
                            {/* {row?._id} */}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
                {loader && (
                  <span style={{ padding: "10px", textAlign: "center" }}>
                    Loading {handlePropertyName()}....
                  </span>
                )}
                {!loader && allProperties?.length === 0 && (
                  <span style={{ padding: "10px", textAlign: "center" }}>
                    No {handlePropertyName()}
                  </span>
                )}
              </Table>
            </TableContainer>
          </>
          <Grid
            container
            style={{ justifyContent: "flex-end", marginTop: "10px" }}
          >
            <button
              className={classes.selectPropButton}
              onClick={() => {
                setsearch("");
                setisShowProperty(false);
              }}
            >
              Close
            </button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
};

export default ShowPropertyModal;
